window.booleanFormatter = function(value, row) {
    if (value === 1 || value === "TRUE") {
        return '<i class="fa fa-check text-success"></i>';
    }
};
